module.exports = __webpack_public_path__ + "static/media/Slide4-mobile.ae5ec91a.jpg";